import React, { useRef, useState } from 'react';
import { UploadIcon } from 'lucide-react';
import { uploadShotReference } from '../../utils/shotReferenceStore';
interface ShotReferenceUploadProps {
  projectId: string;
  value: string;
  onChange: (url: string) => void;
}

/**
 * Replaces the old "paste an image URL" field (9 Sep 2026, at Tom's
 * request — finding and hosting an image just to paste its URL was real
 * friction for whoever was filling in the shot list). Uploads straight to
 * Supabase Storage and stores only the resulting public URL, same pattern
 * call sheet PDFs already use in utils/callSheetStore.ts.
 */
export function ShotReferenceUpload({
  projectId,
  value,
  onChange
}: ShotReferenceUploadProps) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState('');
  async function pick(file: File | undefined) {
    if (!file) return;
    setFailed('');
    setBusy(true);
    const result = await uploadShotReference(projectId, file);
    setBusy(false);
    if (!result.ok || !result.url) {
      setFailed(result.error ?? 'That image could not be saved.');
      return;
    }
    onChange(result.url);
  }
  return <div className="flex items-center gap-3" data-id="element-1448" data-mp="3ezfklbpr2e8a">
      {value ? <img src={value} alt="" className="h-14 w-14 shrink-0 border border-paper/20 object-cover" data-id="element-1449" data-mp="3exma1lc0n9v0" /> : null}
      <div className="min-w-0 flex-1" data-id="element-1450" data-mp="39yrr8je1tlaw">
        <div className="flex flex-wrap items-center gap-4" data-id="element-1451" data-mp="35zak7liz4g3m">
          <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} className="label-sm flex items-center gap-2 text-paper/50 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper disabled:cursor-not-allowed disabled:opacity-40" data-id="element-1452" data-mp="30zxp6dhy82py">
            <UploadIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-1453" data-mp="u8f3j3b91sql" />
            {busy ? 'Uploading…' : value ? 'Replace image' : 'Add image'}
          </button>
          {value && !busy ? <button type="button" onClick={() => onChange('')} className="label-sm text-paper/30 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper" data-id="element-1454" data-mp="2jqbuuqxpu8u8">
              Remove
            </button> : null}
        </div>
        {failed ? <p role="alert" className="label-sm mt-1 text-paper/60" data-id="element-1455" data-mp="2ersb8x6lh951">
            {failed}
          </p> : null}
      </div>
      <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={event => {
      void pick(event.target.files?.[0]);
      event.target.value = '';
    }} className="hidden" data-id="element-1456" data-mp="37g6839ly5zf0" />
    </div>;
}